import {
  Document,
  Image,
  Link,
  Page,
  StyleSheet,
  Text,
} from '@react-pdf/renderer';
import { ReactNode } from 'react';
import React from 'react';

import { CarrierFactory } from '../../../../../../common/carrierConfig/carrierFactory';
import { Carriers } from '../../../../../../common/constants/carriers';
import signatureUri from '../assets/signature.png';
import { formatDate } from '../utils';

export interface LetterProps {
  fullName: string;
  date: string;
  carrier: Carriers;
  policyNumber: string;
  email: string;
  phone: string;
  children: ReactNode;
  isJuvenile?: boolean;
  insuredName?: string;
}

const Letter = ({
  fullName,
  date,
  carrier,
  email,
  phone,
  children,
  policyNumber,
  isJuvenile = false,
  insuredName,
}: LetterProps) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <Image
        style={styles.logo}
        source={{
          uri: CarrierFactory.getCarrierConfig(carrier)?.getCarrierLogo() ?? '',
        }}
      />
      <Text style={styles.text}>{formatDate(date)}</Text>
      <Text style={[styles.text, styles.bold]}>
        Life Application: {policyNumber}
      </Text>
      {isJuvenile && (
        <Text style={[styles.text, styles.bold]}>
          Subject: Life insurance application on the life of{' '}
          {insuredName || '[Name of Insured]'} (proposed life insured).
        </Text>
      )}
      <Text style={styles.text}>Dear {fullName},</Text>
      {children}
      <Text style={styles.text}>
        Thank you again for your interest in{' '}
        {CarrierFactory.getCarrierConfig(carrier)?.getCarrierDisplayName()}.
        Should you have any further questions or comments regarding this letter,
        please contact our customer experience team at{' '}
        <Link href={`tel:${phone}`}>{phone}</Link> or email us at{' '}
        <Link href={`mailto:${email}`}>{email}</Link>.
      </Text>
      <Text style={styles.text}>Sincerely,</Text>
      <Image style={styles.signature} source={{ uri: signatureUri }} />
      {CarrierFactory.getCarrierConfig(carrier)?.getLetterFooterText() && (
        <Text
          style={styles.footer}
          render={() =>
            CarrierFactory.getCarrierConfig(carrier)?.getLetterFooterText()
          }
          fixed
        />
      )}
    </Page>
  </Document>
);

const styles = StyleSheet.create({
  page: {
    display: 'flex',
    flexDirection: 'column',
    padding: 40,
  },
  logo: {
    alignSelf: 'flex-end',
    maxHeight: 140,
    maxWidth: 140,
    objectFit: 'contain',
  },
  bold: {
    fontWeight: '700',
  },
  text: {
    fontSize: 10,
    lineHeight: 1.4,
    marginBottom: 12,
  },
  signature: {
    height: 30,
    alignSelf: 'flex-start',
  },
  footer: {
    position: 'absolute',
    fontSize: '8pt',
    bottom: 30,
    left: 30,
    right: 30,
    textAlign: 'left',
  },
});

export default Letter;
